import React from "react";
import { useTheme } from "../context/ThemeContext";

const DesktopOnly = ({ children }) => {
  const { darkMode } = useTheme();

  return (
    <>
      {/* Mobile Overlay - Always visible on mobile devices */}
      <div className="md:hidden fixed inset-0 z-[9999] flex items-center justify-center bg-gradient-to-br from-black to-gray-900">
        <div
          className={`${
            darkMode
              ? "bg-gray-800/80 backdrop-blur-lg"
              : "bg-white/90 backdrop-blur-lg"
          } rounded-2xl p-8 max-w-sm mx-4 text-center shadow-2xl border ${
            darkMode ? "border-gray-700" : "border-gray-200"
          }`}
        >
          {/* Icon Container */}
          <div
            className={`mb-6 p-4 rounded-full inline-block ${
              darkMode ? "bg-gray-700/50" : "bg-gray-100"
            }`}
          >
            <span className="text-5xl block">💻</span>
          </div>

          {/* Title */}
          <h2
            className={`text-2xl font-bold mb-4 ${
              darkMode ? "text-white" : "text-gray-900"
            }`}
          >
            Desktop Access Only
          </h2>

          {/* Description */}
          <p
            className={`mb-6 ${
              darkMode ? "text-gray-300" : "text-gray-600"
            } leading-relaxed`}
          >
            This trading platform requires a desktop environment for optimal
            performance and precision trading tools.
          </p>

          {/* Requirements Box */}
          <div
            className={`p-4 rounded-lg ${
              darkMode ? "bg-gray-700/50" : "bg-gray-100"
            } mb-6`}
          >
            <h3
              className={`font-medium mb-2 ${
                darkMode ? "text-gray-200" : "text-gray-700"
              }`}
            >
              System Requirements
            </h3>
            <ul
              className={`text-sm ${
                darkMode ? "text-gray-400" : "text-gray-600"
              }`}
            >
              <li className="mb-1">• Minimum screen width: 1024px</li>
              <li className="mb-1">• Desktop browser</li>
              <li>• Mouse/trackpad recommended</li>
            </ul>
          </div>

          {/* Additional Info */}
          <p
            className={`text-sm ${
              darkMode ? "text-gray-400" : "text-gray-500"
            }`}
          >
            Please switch to a desktop computer to access the platform.
          </p>
        </div>
      </div>

      {/* Main Content - Only visible on desktop */}
      <div className="hidden md:block">{children}</div>
    </>
  );
};

export default DesktopOnly;
